<template>
  <div style="display: inline-block"><v-img :src="emoji" :width="size" :height="size" /></div>
</template>

<script>
import emoji from '@/assets/img/emoji/clapping_hands_3d_default.png'
export default {
  data() {
    return {
      emoji: emoji,
    }
  },
  props: {
    size: String,
  },
  name: 'FluentEmojiClappingHands',
}
</script>
